<template>
  <!--:class="{'main--gray-bg' : !sidebarDesktopVisible}"-->
  <template v-if="0">
    <div v-if="!sidebarMobileVisible" class="mobile-bottom-bar">
      <div class="mobile-bottom-bar__column bg-gray">
        <div
          class="btn2 btn--sm btn--gray btn--icon"
          @click="sidebarMobileVisible = true"
        >
          <div class="btn__icon btn__icon--filter btn__icon--bg"></div>
          <div class="btn__text">
            Filtruj wyniki
            <div class="btn__text__count btn__text__count--dark-gray">
              {{ activeFiltersCount }}
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-bottom-bar__column bg-light-gray">

      </div>
    </div>
  </template>
  <div class="products-loading" v-if="loading"></div>

  <template v-if="ready">
    <div
      class="filters-container filters-container--sidebar"
      :class="{
        'filters--mobile': sidebarMobileVisible,
        'filters--desktop': sidebarDesktopVisible,
      }"
    >
      <div class="filters__header">
        <div class="filters__header__title">Filtruj</div>
        <div
          class="filters__header__close"
          @click="sidebarMobileVisible = false"
        >╳
        </div>
      </div>
      <div class="filters__groups">
        <div class="filters__tools">
          <div
            v-if="activeFiltersCount > 0"
            class="btn2 btn--sm btn--gray btn--icon btn--clear-filters"
            @click="clearFilters()"
          >
            <div class="btn__text">
              Wyczyść wybrane filtry ({{ activeFiltersCount }})
            </div>
            <div class="btn__icon btn__icon--bg btn__icon--cross"></div>
          </div>
        </div>
        <template v-for="filter in filters">
          <component
            :is="filter.filter.view"
            :filters="filters"
            :filter="filter"
            @change="filterChange()">
          </component>
        </template>
      </div>
    </div>
    <div class="products-container">
      <template v-if="activeFiltersCount > 0">
        {{ activeFiltersCount }}
        <button @click="clearFilters()">Wyczyść</button>
      </template>
      <pagination v-model="page" :pages="max_num_pages"></pagination>
      <div class="products-grid">
        <template v-for="product in products">
          <product-tile :product="product"></product-tile>
        </template>
      </div>
    </div>
  </template>
</template>

<script>
import { request } from "../utils/request.js";
import range from "../components/filters/Range.vue";
import prices from "../components/filters/Prices.vue";
import checkboxes from "../components/filters/Checkboxes.vue";
import dummy from "../components/filters/Dummy.vue";
import productTile from "../components/ProductTile.vue";
import pagination from "../components/Pagination.vue";
import { filtersToUrl, buildAppUrl, buildWooUrl } from "../utils/utils.js";

export default {
  components: {
    prices: prices,
    range: range,
    checkboxes: checkboxes,
    dummy: dummy,
    productTile: productTile,
    pagination: pagination
  },
  data() {
    return {
      filters: [],
      count: 0,
      loading: false,
      page: 1,
      max_num_pages: null,
      viewMode: "grid",
      moreFilters: false,
      ready: false,
      sidebarMobileVisible: false,
      sidebarDesktopVisible: true
    };
  },
  async created() {
    console.log("created");
  },
  watch: {
    page() {
      this.fetchData();
    }
  },
  async mounted() {
    let wooUrl = buildWooUrl(this.$route.query, this.$route.query.page);
    let data = await request(wooUrl);
    this.filters = data.filters;
    console.log(this.filters, data.filters);
    if (Number.isInteger(parseInt(this.$route.query.page))) {
      this.page = parseInt(this.$route.query.page);
      if (this.page == 0) {
        this.page = 1;
      }
    }
    this.max_num_pages = data.max_num_pages;
    this.products = data.products;
    this.ready = true;
    console.log("mounted");
  },
  computed: {
    activeFiltersCount() {
      return this.filters
        .map(a => a.filter.values)
        .reduce((count, v) => {
          if (v.hasOwnProperty("min") || v.hasOwnProperty("max")) {
            return count + 1;
          } else if (Array.isArray(v)) {
            return count + v.length;
          } else return count;
        }, 0);
    }
  },
  methods: {
    async clearFilters() {
      this.filters.forEach((el) => {
        let v = el.filter.values;
        if (v.hasOwnProperty("min") || v.hasOwnProperty("max")) {
          el.filter.values = {};
        } else if (Array.isArray(v)) {
          el.filter.values = [];
        }
      });

      await this.filterChange();
    },
    async fetchData() {
      this.loading = true;
      let data = await request(filtersToUrl(this.filters, this.page));
      this.filters = data.filters;
      this.products = data.products;
      this.max_num_pages = data.max_num_pages;
      this.refreshUrl();
      this.loading = false;
    },
    async filterChange() {
      console.log("filterChange");
      this.page = 1;
      await this.fetchData();
    },
    refreshUrl() {
      let params = buildAppUrl(this.filters, this.page);
      this.$router.push({ query: params });
    }
  }
};
</script>
